export const getRebateParams = (rebateString: string) => {
  if (!rebateString) return;

  const [tier, rebatePercentage, incomeRange] = rebateString.split('-');

  if (tier === 'No Rebate') {
    return {
      income_tier: 3,
      claiming_rebate: false,
    };
  }

  const rebate_percentage =
    parseFloat(rebatePercentage.replace('%', '').replace('Rebate', '')) / 100;

  switch (tier) {
    case 'Base Tier':
      return {
        income_tier: 0,
        claiming_rebate: true,
        rebate_percentage,
      };
    case 'Tier 1':
      return {
        income_tier: 1,
        claiming_rebate: true,
        rebate_percentage,
      };
    case 'Tier 2':
      return {
        income_tier: 2,
        claiming_rebate: true,
        rebate_percentage,
      };
    case 'Tier 3':
      return {
        income_tier: 3,
        claiming_rebate: true,
        rebate_percentage,
      };
  }
};

export const getRebateFromArgAnswer = (rebateString: string) => {
  if (rebateString === 'No Rebate') {
    return {
      income_tier: 3,
      claiming_rebate: false,
    };
  }
  if (rebateString === 'Base Tier') {
    return {
      income_tier: 0,
      claiming_rebate: true,
      rebate_percentage: 0.24608,
    };
  }
  if (rebateString === 'Tier 1') {
    return {
      income_tier: 1,
      claiming_rebate: true,
      rebate_percentage: 0.16405,
    };
  }
  if (rebateString === 'Tier 2') {
    return {
      income_tier: 2,
      claiming_rebate: true,
      rebate_percentage: 0.08202,
    };
  }
  if (rebateString === 'Tier 3') {
    return {
      income_tier: 3,
      claiming_rebate: true,
      rebate_percentage: 0,
    };
  }
};

export const getTierBasedOnIndex = (index: number) => {
  switch (index) {
    case 0:
      return 'Base Tier';
    case 1:
      return 'Tier 1';
    case 2:
      return 'Tier 2';
    case 3:
      return 'Tier 3';
    default:
      return 'No Rebate';
  }
};
